import { EXTERNAL_CHANNEL } from 'src/data/channel';
import { EXTERNAL_CONNECTION_OBJECT_SEARCH } from 'src/data/performance';

import { getPromptMenuTypeChannel } from './menuType';

export const getExternalChannelFilterOptions = (menuType) => {
  const channel = getPromptMenuTypeChannel(menuType);

  const commonOptions = [
    EXTERNAL_CONNECTION_OBJECT_SEARCH.all,
    EXTERNAL_CONNECTION_OBJECT_SEARCH.lead,
    EXTERNAL_CONNECTION_OBJECT_SEARCH.contact,
    EXTERNAL_CONNECTION_OBJECT_SEARCH.account,
    EXTERNAL_CONNECTION_OBJECT_SEARCH.opportunity,
  ];

  if (channel === EXTERNAL_CHANNEL.salesforceCrm) {
    return commonOptions.concat(EXTERNAL_CONNECTION_OBJECT_SEARCH.case);
  } else if (channel === EXTERNAL_CHANNEL.microsoftDynamicsSales) {
    return commonOptions.concat(EXTERNAL_CONNECTION_OBJECT_SEARCH.quote);
  }
  return Object.values(EXTERNAL_CONNECTION_OBJECT_SEARCH);
};
